import { useEffect, useMemo, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./ScheduleCalendar.css";
import { ScheduleCalendarEvent } from "./ScheduleCalendarEvent";
import { ScheduleCalendarToolbar } from "./ScheduleCalendarToolbar";
import { ScheduleClassDialog } from "./ScheduleClassDialog";
import { ScheduleMobileAgendaView } from "./ScheduleMobileAgendaView";
import {
  getCalendarViewForRange,
  mapAssignmentsToCalendarEvents,
} from "../utils/calendarUtils";

const localizer = momentLocalizer(moment);
const NINE_AM = new Date(1970, 0, 1, 9, 0, 0);

export function ScheduleCalendarView({
  assignments,
  range,
  selectedRangeDays,
  fullPage = false,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [calendarDate, setCalendarDate] = useState(range.start);
  const [calendarView, setCalendarView] = useState(
    getCalendarViewForRange(selectedRangeDays)
  );
  const calendarEvents = useMemo(
    () => mapAssignmentsToCalendarEvents(assignments),
    [assignments]
  );

  useEffect(() => {
    setCalendarDate(range.start);
    setCalendarView(getCalendarViewForRange(selectedRangeDays));
  }, [range.start, selectedRangeDays]);

  if (isMobile) {
    return <ScheduleMobileAgendaView assignments={assignments} />;
  }

  return (
    <Box className={fullPage ? "coach-schedule-calendar full-page" : "coach-schedule-calendar"}>
      <BigCalendar
        localizer={localizer}
        events={calendarEvents}
        startAccessor="start"
        endAccessor="end"
        date={calendarDate}
        view={calendarView}
        views={["day", "week", "month"]}
        onNavigate={setCalendarDate}
        onView={setCalendarView}
        toolbar
        popup
        selectable={false}
        scrollToTime={NINE_AM}
        style={{ height: fullPage ? "calc(100vh - 270px)" : 640, minHeight: fullPage ? 680 : 640 }}
        onSelectEvent={(event) => setSelectedAssignment(event.resource)}
        components={{
          event: ScheduleCalendarEvent,
          toolbar: ScheduleCalendarToolbar,
        }}
      />

      <ScheduleClassDialog
        assignment={selectedAssignment}
        open={Boolean(selectedAssignment)}
        onClose={() => setSelectedAssignment(null)}
      />
    </Box>
  );
}
